import { CalendarClock, Check } from "lucide-react";

const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const followUpState = (iso) => {
  if (!iso) return null;
  const today = todayISO();
  if (iso < today) return "overdue";
  if (iso === today) return "today";
  return "upcoming";
};

const STYLES = {
  overdue: "bg-red-50 text-red-700 border-red-200",
  today: "bg-amber-50 text-amber-800 border-amber-200",
  upcoming: "bg-emerald-50 text-emerald-800 border-emerald-200",
};

const LABELS = { overdue: "Overdue", today: "Due today", upcoming: "Follow up" };

const formatDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export const FollowUpBadge = ({ lead, onDone }) => {
  const state = followUpState(lead.follow_up_at);
  if (!state) return null;
  return (
    <span
      data-testid={`follow-up-badge-${lead.reference}`}
      data-state={state}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${STYLES[state]}`}
    >
      <CalendarClock className="w-3.5 h-3.5" />
      {LABELS[state]} · {formatDate(lead.follow_up_at)}
      <button
        type="button"
        data-testid={`follow-up-done-${lead.reference}`}
        onClick={() => onDone(lead.id, null)}
        title="Mark follow-up done"
        className="ml-1 rounded-full p-0.5 hover:bg-white/70 transition-colors"
      >
        <Check className="w-3.5 h-3.5" />
      </button>
    </span>
  );
};
